import { selectSvedocenja } from '../../reducers/svedocenjaReducer.js';
import { fetchSvedocenja } from '../../fetch/documents.js';
import { selectLoadingRecentDocuments } from '../../reducers/recentDocumentsReducer.js';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectLangObj } from '../../reducers/langReducer.js';
import SliderElement from '../slider/SliderElement.js';
import SliderItem from '../../models/SliderItem.js';
import DocumentSlider from '../slider/DocumentSlider.js';
import MoreInfo from './MoreInfo.js';
import GridType from '../../models/GridType.ts';


function SvedocenjaSlider(props) {
  const svedocenja = useSelector(selectSvedocenja);
  const dispatch = useDispatch();
  const langObj = useSelector(selectLangObj);

  const appendItems = () => {
    dispatch(fetchSvedocenja());
  }
  useEffect(() => {

    appendItems();
  }, []);

  function getItems(recentDocuments){


    return recentDocuments.map(e => { return new SliderItem( e.рбр, e.наслов,e.линкП, e.линк,e.датум, e.прикупио); }).map(e => {

      return (
        <SliderElement auto={false} key={e.url} data={e}></SliderElement>
      )
    })
  }

  return (
    
 
    <DocumentSlider moreElement={<MoreInfo moreLink={"/Grid/" + GridType.Svedocenja}/>} title={langObj["Svedocenja"]} appendItems={appendItems} getItems={()=>getItems(svedocenja)}  ></DocumentSlider>
  );
}

export default SvedocenjaSlider;
